import React from 'react';
import { PageHead, Section, Eyebrow, PageTitle, Lede, Button, Card, CardTitle, CardBody, Grid, CONTACT_MAILTO, LINKEDIN_URL } from '../components/ui';

/** Start a conversation. One button, which opens a prefilled email. */
const ContactPage = () => (
  <>
    <PageHead title="Start a conversation" description="Bring the decision you are stuck on. One conversation, no deck. Right Brain Labs, New Albany, Ohio." path="/contact" />
    <Section tone="page" reveal={false}>
      <Eyebrow>Start a conversation</Eyebrow>
      <PageTitle>Bring the decision you are stuck on.</PageTitle>
      <Lede>One conversation, no deck. Tell us what you are facing and we will say whether we are the right people for it. If we are not, we will point you to who is.</Lede>
      <div className="mt-8 flex flex-wrap gap-3">
        <Button href={CONTACT_MAILTO}>Send us an email</Button>
        <Button href={LINKEDIN_URL} variant="secondary">Message on LinkedIn</Button>
      </div>
    </Section>
    <Section tone="card">
      <Grid cols={3}>
        <Card><CardTitle>Advisory</CardTitle><CardBody>A decision about AI that has stalled, a board that needs the right questions, a strategy that should compound capability.</CardBody></Card>
        <Card><CardTitle>Speaking</CardTitle><CardBody>A keynote, a board session, or a working day with your team, built around Thinking with AI.</CardBody></Card>
        <Card><CardTitle>The Apprenticeship</CardTitle><CardBody>A cohort of 10 to 15 from your organization, a real problem, 30 to 60 days, and a practice that stays.</CardBody></Card>
      </Grid>
    </Section>
  </>
);

export default ContactPage;
